import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import ConfirmModal from '../modals/ConfirmModal.jsx';
import useMarketPlaceModal from "../../pages/Layout/DashboardLayout/MarketPlaceModal/useMarketPlaceModal";
import { locationWiseData } from '../../services/regionalLevelSales';
import { crown, dummyImage } from "../../../images/index.js";
import AreaTableModal from "../modals/AreaTableModal.jsx";
import { usePermissions } from "../../context/PermissionContext.js";
import { useLocation } from "react-router-dom";
import { getColumnSetting } from "../../services/columnSetting.js";

const NormalTable = ({
    tableId,
    data,
    selectedIds = { categoryId: [], productId: [] },
    onSelectionChange,
    idKey = "id",
    typeKey = "type",
    enableSelection = true,
    prioritizeSelected = false,
    defaultPageLength = 10,
    refreshTrigger,
    onCategoryClick,
    onParentProductClick,
    loading = false,
    sequence,
    filterData = {},
    downloadBtnPermission = true,
    isProductwiseTable = true,
    selectedCheckBoxIds,
    onColumnChange = () => { },
    showSelectColumn = false,
    section
}) => {
    const { handleConnect } = useMarketPlaceModal();
    const [modalOpenLoading, setModalOpenLoding] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const containerRef = useRef(null);
    const selectedIdsRef = useRef(new Set());
    const [showInfoComponent, setShowInfoComponent] = useState(false);
    const [infoData, setInfoData] = useState({ column: "", rowId: "" });
    const [delayedEmpty, setDelayedEmpty] = useState(false);
    const [selectedLocationName, setSelectedLocationName] = useState("");
    const [locationModalOpen, setLocationModalOpen] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const { formattedStart, formattedEnd, level } = filterData;
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [tempColumns, setTempColumns] = useState([]);
    const headersRef = useRef([]); // store headers globally
    const [allColumns, setAllColumns] = useState([]);
    const location = useLocation();
    const [selectedLocationDetails, setSelectedLocationDetails] = useState({
        state: "",
        city: "",
        pincode: ""
    });
    const permission = usePermissions();
    const dataTableRef = useRef(null);

    // Utility to prevent HTML execution and attribute breaking (XSS protection)
    const escapeHTML = (str) => {
        if (str === null || str === undefined) return "";
        if (typeof str !== 'string') str = String(str);
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')    // Fixes double quotes breaking attributes
            .replace(/'/g, '&#39;')     // Fixes single quotes
            .replace(/\//g, '&#x2F;')   // Fixes forward slashes
            .replace(/\\/g, '&#x5C;');  // Fixes backslashes
    };

    useEffect(() => {
        if (!loading) {
            if (Array.isArray(data) && data.length === 0) {
                setDelayedEmpty(true);
            } else {
                setDelayedEmpty(false);
            }
        } else {
            setDelayedEmpty(false);
        }
    }, [loading, data]);

    useEffect(() => {
        if (selectedCheckBoxIds === null) {
            // FORCE CLEAR (important)
            selectedIdsRef.current = new Set();
        } else if (Array.isArray(selectedCheckBoxIds)) {
            selectedIdsRef.current = new Set(
                selectedCheckBoxIds.map(id =>
                    idKey === "targeting" || idKey === "customer_search_term" ? normalizeTargeting(id) : String(id)
                )
            );
        }
    }, [selectedCheckBoxIds]);


    useEffect(() => {
        const flatSelected = [
            ...(selectedIds.productId || []),
            ...(selectedIds.categoryId || [])
        ];

        const current = new Set(selectedIdsRef.current);
        const incoming = new Set(flatSelected);

        const isDifferent =
            current.size !== incoming.size ||
            [...current].some(id => !incoming.has(id));

        if (isDifferent) {
            selectedIdsRef.current = incoming;
        }
    }, [selectedIds]);
    const ALWAYS_VISIBLE_COLUMNS = [
        "campaign_name",
        "adgroup_name",
        "product_name",
        "name",
        "targeting",
        "search_term",
        "customer_search_term"
    ];

    const parseCurrency = (value) => {
        if (typeof value !== "string" && typeof value !== "number") return null;

        // Normalize and clean input
        let str = String(value).trim().replace(/[₹,%\s]/g, '').toUpperCase();

        // Handle Crores
        if (str.endsWith('CR')) {
            const num = parseFloat(str.replace('CR', ''));
            return isNaN(num) ? null : num * 10000000;
        }

        // Handle Lakhs
        if (str.endsWith('L')) {
            const num = parseFloat(str.replace('L', ''));
            return isNaN(num) ? null : num * 100000;
        }

        // Handle Thousands
        if (str.endsWith('K')) {
            const num = parseFloat(str.replace('K', ''));
            return isNaN(num) ? null : num * 1000;
        }

        // Handle plain numeric with commas (e.g., "1,962")
        str = str.replace(/,/g, '');
        const numeric = parseFloat(str);
        return isNaN(numeric) ? null : numeric;
    };

    const normalizeTargeting = (val) => {
        if (!val) return "";
        return val
            .replace(/\\/g, '')
            .replace(/"/g, '"')

    };
    useEffect(() => {
        const fetchColumns = async () => {
            try {
                const res = await getColumnSetting(section);

                if (res?.data?.success && Array.isArray(res?.data?.data)) {
                    const apiColumns = res.data.data; // full array

                    setAllColumns(apiColumns); // <-- NEW STATE
                    // setTempColumns(
                    // apiColumns.filter(c => c.visible).map(c => c.key)
                    // );
                    // setVisibleColumns(
                    // apiColumns.filter(c => c.visible).map(c => c.key)
                    // );
                    const apiVisible = apiColumns.filter(c => c.visible).map(c => c.key);

                    const finalCols = [...new Set([...apiVisible, ...ALWAYS_VISIBLE_COLUMNS])];

                    setTempColumns(finalCols);
                    setVisibleColumns(finalCols);
                }
            } catch (err) {
                console.error("Column fetch failed", err);
            }
        };
        if (section) {
            fetchColumns();
        }
    }, [section, tableId, typeKey, location.pathname]);

    useEffect(() => {
        if (headersRef.current.length && tempColumns.length) {
            setVisibleColumns(tempColumns);
        }
    }, [tempColumns]);


    useEffect(() => {
        const initialize = async () => {
            if (!containerRef.current) return;

            // 1. Target the specific scroll wrapper
            const wrapper = document.getElementById(`scroll-wrapper-${tableId}`);
            // important 
            const previousScrollTop = wrapper ? wrapper.scrollTop : 0;
            const previousScrollLeft = wrapper ? wrapper.scrollLeft : 0;
            try {
                const existingTable = $(`#${tableId}`);
                if (!dataTableRef.current) {
                    dataTableRef.current = $(`#${tableId}`).DataTable({
                        pageLength: defaultPageLength,
                        ordering: true,
                        order: [],
                    });
                }

                if (loading) {
                    containerRef.current.innerHTML = getSkeletonTableHTML();
                    return;
                }

                if (!data.length) {
                    // Wait until delayedEmpty is true
                    if (delayedEmpty) containerRef.current.innerHTML = "";
                    return;
                }


                await import("../../../datatable.js");

                const sortByType = (a, b) => {
                    const priority = { Category: 0, Product: 1 };
                    return (priority[a.type] ?? 2) - (priority[b.type] ?? 2);
                };

                // const processedData = prioritizeSelected
                //     ? [...data].sort((a, b) => {
                //         const idA = idKey === "targeting" || idKey === "customer_search_term"
                //             ? normalizeTargeting(a[idKey])
                //             : a[idKey]?.toString();

                //         const idB = idKey === "targeting" || idKey === "customer_search_term"
                //             ? normalizeTargeting(b[idKey])
                //             : b[idKey]?.toString();
                //         const selectedDiff =
                //             Number(selectedIdsRef.current.has(idB)) -
                //             Number(selectedIdsRef.current.has(idA));
                //         if (selectedDiff !== 0) return selectedDiff;
                //         return sortByType(a, b);
                //     })
                //     : [...data].sort(sortByType);
                // const processedData = [...data]
                const processedData = [...data].sort((a, b) => {
                    const idA = idKey === "targeting" || idKey === "customer_search_term"
                        ? normalizeTargeting(a[idKey])
                        : a[idKey]?.toString();

                    const idB = idKey === "targeting" || idKey === "customer_search_term"
                        ? normalizeTargeting(b[idKey])
                        : b[idKey]?.toString();

                    const isASelected = selectedIdsRef.current.has(idA);
                    const isBSelected = selectedIdsRef.current.has(idB);

                    //  selected rows first
                    if (isASelected !== isBSelected) {
                        return isBSelected - isASelected;
                    }

                    //  optional: keep your type sorting
                    const priority = { Category: 0, Product: 1 };
                    return (priority[a.type] ?? 2) - (priority[b.type] ?? 2);
                });

                const showASIN_SKU = [
                    "product",
                    "productGrowthId",
                    "salesByState",
                    "topSellingProducts",
                    "topSellingCategory"
                ].includes(tableId);

                let headers = Object.keys(processedData[0] || {}).filter((h) => {
                    const excludeFields = ["type", "image", "status"];
                    if (tableId === "product") {
                        excludeFields.push("asin", "sku", "brand");
                    }
                    return !excludeFields.includes(h);
                });
                headersRef.current = headers;
                const columnMapping = {
                    actual_units: "actual_sold_units",
                };

                // Apply sequence.columns if defined and is a valid array
                if (Array.isArray(sequence?.columns) && sequence.columns.length > 0) {
                    headers = sequence.columns
                        .map(col => columnMapping[col] || col)
                        .filter(col => headers.includes(col));
                }

                const selectedCheckBoxSet = new Set(
                    (selectedCheckBoxIds || []).map(id =>
                        idKey === "targeting" || idKey === "customer_search_term"
                            ? normalizeTargeting(id)
                            : String(id)
                    )
                );
                const isExternalSelection = Array.isArray(selectedCheckBoxIds);
                const isForceUncheck = selectedCheckBoxIds === null;
                const tableHTML = `

        <div class="table-scroll-wrapper" id="scroll-wrapper-${tableId}">
          <table id="${tableId}" class="display table freeze-table" style="width:100%">
            <thead class="table-header">
              <tr class="table-header">
               <th style="display:none"></th> 
                ${enableSelection ? `<th class="sticky-col checkbox-col not_export table-header kpi-name"><input type="checkbox" id="select-all-${tableId}" /></th>` : ""}
                ${headers
                        .filter(key => !(key === idKey && idKey !== "campaign_id" && idKey !== "adgroup_id" && idKey !== "targeting" && idKey !== "product_id" && idKey !== "search_term" && idKey !== "customer_search_term"))
                        .filter(key => visibleColumns.length === 0 || visibleColumns.includes(key))
                        .map((h, idx) => {
                            let label = h
                                .replace(/_/g, " ")
                                .split(" ")
                                .map(word => {
                                    const lower = word.toLowerCase();
                                    if (lower === "percentage") return "%";
                                    if (lower === "ads") return "Ads";
                                    if (lower === "adgroup_name") return "Ad GROUP NAME";
                                    if (lower === "tacos") return "TACoS";
                                    return word.toUpperCase();
                                })
                                .join(" ");
                            const extraClass = (!enableSelection && idx === 0) || (enableSelection && idx === 0)
                                ? "sticky-col name-col table-header"
                                : "table-header";
                            return `<th class="${extraClass}">${label}</th>`;
                        })
                        .join("")}
              </tr>
            </thead>
            <tbody style="vertical-align: middle;"> 
              ${processedData
                        .map(row => {
                            const rawId = row[idKey];
                            const safeTargeting = encodeURIComponent(rawId);
                            const rowId = idKey === "targeting" || idKey === "customer_search_term"
                                ? normalizeTargeting(rawId)
                                : rawId?.toString() || "";

                            const rowType = row[typeKey]?.toString() || "";

                            const isChecked = isForceUncheck
                                ? ""
                                : isExternalSelection
                                    ? selectedCheckBoxSet.has(rowId) ? "checked" : ""
                                    : selectedIdsRef.current.has(rowId) ? "checked" : "";
                            const isSelected = selectedIdsRef.current.has(rowId);

                            return `
                    <tr data-id="${escapeHTML(rowId)}" data-type="${escapeHTML(rowType)}">
                    <td style="display:none">${isSelected ? 0 : 1}</td> 
                    
                      ${enableSelection
                                    ? `<td class="sticky-col checkbox-col not_export table-header-content">
                                      <input 
                                        type="checkbox"
                                        tabindex="-1"                               
                                        class="row-checkbox normal-custom-checkbox"
                                        data-id="${safeTargeting}"
                                        data-type="${escapeHTML(rowType)}"
                                        ${isChecked}
                                      />
                                     </td>`
                                    : ""
                                }
                      ${headers
                                    .filter(key => !(key === idKey && idKey !== "campaign_id" && idKey !== "adgroup_id" && idKey !== "targeting" && idKey !== "search_term" && idKey !== "product_id" && idKey !== "customer_search_term"))
                                    .filter(key => visibleColumns.length === 0 || visibleColumns.includes(key))
                                    .map((key, idx) => {
                                        // THIS IS WHERE WE ESCAPE HTML VALUES SO THEY DONT RENDER AS CODE
                                        const cellValue = (row[key] === null || row[key] === undefined || row[key] === "")
                                            ? "NA"
                                            : escapeHTML(row[key]);

                                        const orderValue = parseCurrency(cellValue);
                                        const extraClass = (!enableSelection && idx === 0) || (enableSelection && idx === 0)
                                            ? "sticky-col campaig-sticky-col name-col table-header-content"
                                            : "";
                                        const cellContent =
                                            key === "type" || key === "image"
                                                ? ""
                                                : (key === "name" || key === "product_name" || key === "campaign_name" || key === "adgroup_name")
                                                    ? (() => {

                                                        if (tableId === "product") {
                                                            return `

                                                            <div style="display:flex; align-items:center; gap:10px;">
                                                                
                                                                <img 
                                                                    src="${row['image'] && row['image'].trim() !== '' ? row['image'] : dummyImage}"
                                                                    width="70" 
                                                                    height="70" 
                                                                    style="border-radius:4px;object-fit:cover;" 
                                                                />

                                                                <div>
                                                                    <a 
                                                                        href="https://www.amazon.in/dp/${escapeHTML(row.asin || "")}" 
                                                                        target="_blank"
                                                                        class="truncate-2-lines"
                                                                        style="cursor:pointer;color:#007bff;text-decoration:none;"
                                                                        title="${escapeHTML(row.name || row.product_name)}"
                                                                    >
                                                                        ${escapeHTML(row.name || row.product_name || "-")}
                                                                    </a>

                                                                    <div style="font-size:12px; margin-top:4px;">
                                                                        ${row.brand ? `<span class="budget-chip mb-1 d-inline-block"><span class="lbl">Brand: </span><span class="val">${escapeHTML(row.brand)}</span></span><br>` : ""}
                                                                        
                                                                        ${row.asin ? `<span class="budget-chip"> <span class="val">${escapeHTML(row.asin)}</span></span>` : ""}
                                                                        
                                                                        ${row.asin && row.sku ? ` ` : ""}
                                                                        
                                                                        ${row.sku ? `<span class="budget-chip"> SKU: <span class="val">${escapeHTML(row.sku)}</span></span>` : ""}
                                                                    </div>
                                                                </div>

                                                            </div>`;
                                                        }
                                                        //  if campaign column → custom UI
                                                        if (key === "campaign_name") {
                                                            const status = row.status || "";
                                                            const budget = row.budget || "";

                                                            let cls = "";
                                                            if (status === "ENABLED") cls = "enabled";
                                                            else if (status === "PAUSED") cls = "paused";

                                                            return `

                                                            <div>
                                                                <div class="campaign-name">${cellValue}</div>

                                                                <div class="meta-row" style="display:flex; gap:10px; margin-top:4px;">
                                                                <span class="badge ${cls}">${escapeHTML(status)}</span>
                                                                <span class="budget-chip">
                                                                    <span class="lbl">Budget</span>
                                                                    <span class="val">${escapeHTML(budget)}</span>
                                                                </span>
                                                                </div>
                                                            </div>
                                                            `;
                                                        }
                                                        if (key === "adgroup_name") {
                                                            const status = row.status || "";
                                                            const budget = row.budget_amount || "";

                                                            let cls = "";
                                                            if (status === "ENABLED") cls = "enabled";
                                                            else if (status === "PAUSED") cls = "paused";
                                                            return `

                                                            <div>
                                                                <div class="campaign-name">${cellValue}</div>

                                                                <div class="adgroup_campaign_name" style="display:flex; gap:10px; margin-top:4px; align-items:center;">
                                                                <span class="budget-chip">
                                                                    <span class="lbl">Budget</span>
                                                                    <span class="val">${escapeHTML(budget)}</span>
                                                                </span>
                                                                <span class="">
                                                                    <span class="lbl">Campaign Name : </span>
                                                                    <span class="val">${escapeHTML(row["campaign_name"])}</span>
                                                                </span>
                                                                </div>
                                                            </div>
                                                            `;
                                                        }
                                                        return `
                                        
                                        
                                        <div style="display: flex; align-items: center; gap: 10px;">
                                        ${!row.hasOwnProperty("image_url")
                                                                ? ""
                                                                : row["image"] || row["image_url"] || (row["type"] === "Product" || row["type"] === "Parent Product")
                                                                    ? `<img src="${row["image"] && row["image"].trim() !== "" ? row["image"] : dummyImage
                                                                    }" alt="${escapeHTML(row["parent_category"] || "image")}" width="70" height="70" style="border-radius:4px;object-fit:cover;" />`
                                                                    : row["image"] || row["image"] === null || row["image_url"] === null
                                                                        ? `<img alt="Dummy image" src="${dummyImage}" width="70" height="70" class="dummy-img"/>`
                                                                        : ""
                                                            }                                         

                                            <div>
                                            ${row["type"] === "Category"
                                                                ? `<span class="truncate-2-lines "
                                                            data-id="${escapeHTML(rowId)}"
                                                            data-asin="${escapeHTML(cellValue)}"
                                                            style="cursor:pointer; color:#007bff;"
                                                            title="${escapeHTML(cellValue)}">
                                                        ${cellValue}
                                                    </span>`
                                                                : row["type"] === "Parent Product"
                                                                    ? `<span class="truncate-2-lines clickable-parent"
                                                            data-parent-id="${escapeHTML(rowId)}"
                                                            data-product-id="${escapeHTML(row["product_id"] || rowId)}"
                                                            data-asin="${escapeHTML(row["asin"] || row["sku"])}"
                                                            style="cursor:pointer;color:#28a745;"
                                                            title="${escapeHTML(cellValue)}">
                                                        ${cellValue}
                                                    </span>`
                                                                    : row?.asin?.trim?.()
                                                                        ? `<div 
                                                        class="truncate-2-lines"
                                                        style="cursor:pointer;color:#007bff;text-decoration:none;"

                                                    </div>`
                                                                        : row?.sku?.trim?.()
                                                                            ? `<div
                                                        class="truncate-2-lines"
                                                        style="cursor:pointer;color:#007bff;text-decoration:none;"
                                                
                                                    </div>`
                                                                            : `<span class="truncate-2-lines" title="${escapeHTML(cellValue)}">${cellValue}</span>`
                                                            }
                                            <div style="min-width:200px; font-size:14px; margin-top: 4px;">
                                                ${row?.brand?.trim?.() || row?.asin?.trim?.() || row?.sku?.trim?.()
                                                                ? `<div class='custom-text-dark' style="font-size:12px;">
                                                        ${row?.brand?.trim?.()
                                                                    ? `Brand: <span class='text-muted' style="color:#555;">${escapeHTML(row["brand"])}</span><br/>`
                                                                    : ""
                                                                }
                                                        ${row?.asin?.trim?.()
                                                                    ? `ASIN: <span style="color:#555;" class='text-muted'>${escapeHTML(row["asin"])}</span>`
                                                                    : ""
                                                                }
                                                        ${row?.asin?.trim?.() && row?.sku?.trim?.()
                                                                    ? "&nbsp;&nbsp;|&nbsp;&nbsp;"
                                                                    : ""
                                                                }
                                                        ${row?.sku?.trim?.()
                                                                    ? `SKU: <span style="color:#555;" class='text-muted'>${escapeHTML(row["sku"])}</span>`
                                                                    : ""
                                                                }
                                                        </div>`
                                                                : ""
                                                            }
                                                </div>
                                            </div>
                                        </div>`  })()
                                                    : key.toLowerCase() === "location"
                                                        ? `<span class="clickable-location" data-rowid="${escapeHTML(rowId)}" style="cursor:pointer;color:#007bff;text-decoration:underline;">
                                            ${cellValue}
                                            </span>`
                                                        : cellValue === "i"
                                                            ? `<span class="clickable-i" data-key="${escapeHTML(key)}" data-id="${escapeHTML(rowId)}" title="Connect your Ads Account"> <img class="normal-table-crown-img" src="${crown}"/> </span>`
                                                            : cellValue ?? "";


                                        return orderValue == null
                                            ? `<td class="${extraClass}"><div class="${extraClass === "sticky-col campaig-sticky-col name-col table-header-content h-100" ? "" : "long-word-wrap"}">${cellContent}</div></td>`
                                            : `<td class="${extraClass}" data-order="${orderValue}">${cellContent}</td>`;
                                    })
                                    .join("")}
                                </tr>`;
                        })
                        .join("")}
                                </tbody>
                            </table>
                            `;

                containerRef.current.innerHTML = tableHTML;

                // ✅ restore previous scroll position
                requestAnimationFrame(() => {
                    const wrapper = document.getElementById(`scroll-wrapper-${tableId}`);
                    if (wrapper) {
                        wrapper.scrollTop = previousScrollTop;
                        wrapper.scrollLeft = previousScrollLeft;
                    }
                });
                setTimeout(() => {
                    const container = document.getElementById(`column-dropdown-${tableId}`);
                    if (!container) return;
                    container.innerHTML = `
                <button id="col-btn-${tableId}" class="btn btn-secondary buttons-csv buttons-html5">
                <i class="bi bi-funnel"></i>
                </button>


                <div class="col-dropdown-box" id="col-dropdown-box-${tableId}"></div>
                `;

                    const btn = document.getElementById(`col-btn-${tableId}`);
                    const box = document.getElementById(`col-dropdown-box-${tableId}`);
                    const excludedColumns = ["id", "asin", "image", "name", "sku", "brand", "actual_units", "term"];

                    btn.onclick = () => {
                        box.style.display = box.style.display === "none" ? "block" : "none";
                        renderCheckboxList();
                    };

                    const renderCheckboxList = () => {
                        box.innerHTML = `
                <div class="dropdown-select-all">
                    <input type="checkbox" id="select-all-cols-${tableId}" />
                    <label style="font-weight:500;">Select All</label>
                </div>
                <div style="max-height:180px; overflow:auto;">
                    ${allColumns
                                .filter(colObj => !excludedColumns.includes(colObj.key))
                                .map(colObj => {
                                    const col = colObj.key;

                                    const label = col
                                        .replace(/_/g, " ")
                                        .split(" ")
                                        .map(word => {
                                            const lower = word.toLowerCase();
                                            if (lower === "percentage") return "%";
                                            if (lower === "ads") return "Ads";
                                            if (lower === "tacos") return "TACoS";
                                            if (lower === "acos") return "ACOS";
                                            if (lower === "roas") return "ROAS";
                                            if (lower === "ctr") return "CTR";
                                            if (lower === "cpc") return "CPC";
                                            return word.charAt(0).toUpperCase() + word.slice(1);
                                        })
                                        .join(" ");

                                    return `
                        <div class="truncate-2-lines">
                            <input type="checkbox" 
                            ${tempColumns.includes(col) ? "checked" : ""}
                            data-col="${col}" />
                            ${ALWAYS_VISIBLE_COLUMNS.includes(col) ? "disabled" : ""}
                            <label>${label}</label>
                        </div>
                        `;
                                }).join("")}
                </div>

                    <div style="display:flex; justify-content:space-between; margin-top:10px;">
                    <button id="close-col-${tableId}" class="btn btn-light w-sm-auto px-3 py-0 rounded-3 border shadow-sm">Close</button>
                    <button id="update-col-${tableId}" class="btn plan-detail-card-btn rounded-3">Update</button>
                    </div>
                `;

                        const selectAllEl = document.getElementById(`select-all-cols-${tableId}`);
                        const columnCheckboxes = box.querySelectorAll("input[data-col]");

                        // all valid columns
                        const dropdownColumns = allColumns
                            .filter(colObj => !excludedColumns.includes(colObj.key))
                            .map(c => c.key);

                        // ✅ set initial state
                        selectAllEl.checked = dropdownColumns.every(col => tempColumns.includes(col));
                        selectAllEl.onchange = (e) => {
                            if (e.target.checked) {
                                // setTempColumns([...new Set([...tempColumns, ...dropdownColumns])]);
                                const updated = [...new Set([...dropdownColumns, ...ALWAYS_VISIBLE_COLUMNS])];
                                setTempColumns(updated);

                                columnCheckboxes.forEach(cb => {
                                    cb.checked = true;
                                });

                            } else {
                                const updated = tempColumns.filter(col => !dropdownColumns.includes(col));
                                setTempColumns(updated);

                                columnCheckboxes.forEach(cb => {
                                    cb.checked = false;
                                });
                            }
                        };

                        columnCheckboxes.forEach(cb => {
                            cb.onchange = (e) => {
                                const col = e.target.getAttribute("data-col");

                                // ❌ block mandatory columns
                                if (ALWAYS_VISIBLE_COLUMNS.includes(col)) {
                                    e.target.checked = true;
                                    return;
                                }

                                let updated;

                                if (e.target.checked) {
                                    updated = [...tempColumns, col];
                                } else {
                                    updated = tempColumns.filter(c => c !== col);
                                }

                                // ✅ always merge mandatory
                                updated = [...new Set([...updated, ...ALWAYS_VISIBLE_COLUMNS])];

                                setTempColumns(updated);

                                const allChecked = [...columnCheckboxes].every(cb => cb.checked);
                                selectAllEl.checked = allChecked;
                            };
                        });
                        document.getElementById(`update-col-${tableId}`).onclick = async () => {
                            const selectedCols = [];

                            box.querySelectorAll("input[data-col]").forEach(cb => {
                                if (cb.checked) selectedCols.push(cb.getAttribute("data-col"));
                            });

                            const excludedColumns = ["id", "asin", "image", "name", "sku", "brand", "campaign_name", "budget", "status", "adgroup_name", "budget_amount", "term"];

                            // ✅ merge excluded columns (force visible)
                            const finalSelectedCols = [
                                ...new Set([...selectedCols, ...excludedColumns, ...ALWAYS_VISIBLE_COLUMNS])
                            ];

                            setVisibleColumns(finalSelectedCols);
                            setTempColumns(finalSelectedCols);

                            onColumnChange?.(finalSelectedCols, headersRef.current, section);

                            box.style.display = "none";
                        };
                        document.getElementById(`close-col-${tableId}`).onclick = () => {
                            setTempColumns(visibleColumns);
                            box.style.display = "none";
                        };
                    };
                }, 0);
                const idColIndex = headers.findIndex(h => h === idKey);
                const checkboxOffset = enableSelection ? 1 : 0;

                window.initializeNormalDataTable({
                    selector: `#${tableId}`,
                    custom_class: "normalTable",
                    pageLength: defaultPageLength,
                    ordering: true,
                    order: [],
                    columnDefs: [
                        ...(enableSelection ? [{ targets: 0, orderable: false }] : []),
                        { targets: idColIndex + checkboxOffset, visible: false },
                    ],
                    downloadBtnPermission,
                    isProductwiseTable,
                    sectionName: 'campaignName'
                });

                const dt = $(`#${tableId}`).DataTable();
                dt.buttons().container().appendTo(`#download-btn-${tableId}`);

                if (showSelectColumn) {
                    const filterContainer = document.querySelector(
                        `#${tableId}_wrapper .custom_data_filter_col .col-6.text-end`
                    );

                    if (filterContainer) {
                        filterContainer.innerHTML = `
                    <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px;">
                    <div id="column-dropdown-${tableId}"></div>
                    <div id="download-btn-${tableId}"></div>
                    </div>
                `;
                    }
                }
                dt.buttons().container().appendTo(`#download-btn-${tableId}`);

                const $table = $(`#${tableId}`).DataTable();
                // const table = dataTableRef.current;
                // const rows = processedData.map(row =>
                //     headers.map(h => {
                //         const value = row[h];

                //         if (value === null || value === undefined) return "NA";

                //         if (typeof value === "object") {
                //             return JSON.stringify(value);
                //         }

                //         return value;
                //     })
                // );
                // table.clear();
                // table.rows.add(rows);
                // table.draw(false);


                const emitGroupedSelected = (currentSet, meta = { isBulk: false }) => {

                    const grouped = { categoryId: [], productId: [] };
                    // Use the set passed or the ref
                    const targetSet = currentSet || selectedIdsRef.current;

                    // Important: We map through the ACTUAL data to find types, 
                    // rather than relying on jQuery selectors which might be slow/unreliable during re-renders
                    targetSet.forEach((id) => {
                        const row = data.find(r => {
                            const raw = r[idKey];
                            const normalized = idKey === "targeting" || idKey === "customer_search_term"
                                ? normalizeTargeting(raw)
                                : raw?.toString();
                            return normalized === id;
                        });
                        if (row) {
                            if (row[typeKey] === "Category") grouped.categoryId.push(id);
                            else grouped.productId.push(id);
                        }
                    });

                    onSelectionChange?.(grouped, meta);
                };


                const handleHeaderSelectAll = () => {

                    const selectAllCheckbox = document.getElementById(`select-all-${tableId}`);
                    if (!selectAllCheckbox) return;

                    $(selectAllCheckbox).off("click").on("click", function () {
                        const isChecked = this.checked;
                        const pageNodes = $table.rows({ page: 'current' }).nodes();
                        const $checkboxes = $(pageNodes).find(".row-checkbox");

                        $checkboxes.each(function () {
                            const encodedId = $(this).attr("data-id");
                            const rawId = decodeURIComponent(encodedId);
                            const rowId = idKey === "targeting" || idKey === "customer_search_term"
                                ? normalizeTargeting(rawId)
                                : rawId?.toString();
                            if (!rowId) return;

                            this.checked = isChecked;
                            if (isChecked) {
                                selectedIdsRef.current.add(rowId);
                            } else {
                                selectedIdsRef.current.delete(rowId);
                            }
                        });

                        // Call this ONLY once after the loop finishes
                        emitGroupedSelected(null, { isBulk: true });
                    });
                };
                handleHeaderSelectAll();


                const restoreCheckboxStates = () => {
                    const selectAllCheckbox = document.getElementById(`select-all-${tableId}`);
                    if (!selectAllCheckbox) return;

                    const pageNodes = $table.rows({ page: 'current' }).nodes();
                    const $checkboxes = $(pageNodes).find(".row-checkbox");

                    if ($checkboxes.length === 0) {
                        selectAllCheckbox.indeterminate = false;
                        selectAllCheckbox.checked = false;
                        return;
                    }

                    let allChecked = true;
                    let someChecked = false;

                    $checkboxes.each(function () {
                        const encodedId = $(this).attr("data-id");
                        const rawId = decodeURIComponent(encodedId);
                        const rowId = idKey === "targeting" || idKey === "customer_search_term"
                            ? normalizeTargeting(rawId)
                            : rawId?.toString();

                        const isChecked = isForceUncheck
                            ? false
                            : isExternalSelection
                                ? selectedCheckBoxSet.has(rowId)
                                : selectedIdsRef.current.has(rowId);

                        this.checked = isChecked;

                        if (!isChecked) {
                            allChecked = false;
                        } else {
                            someChecked = true;
                        }
                    });

                    selectAllCheckbox.checked = allChecked;
                    // selectAllCheckbox.indeterminate = someChecked && !allChecked;
                    selectAllCheckbox.indeterminate = false;
                };

                requestAnimationFrame(() => restoreCheckboxStates());
                $table.on("draw", () => {
                    restoreCheckboxStates();

                    const wrapper = document.getElementById(`scroll-wrapper-${tableId}`);
                    if (wrapper) {
                        wrapper.scrollTop = previousScrollTop;
                        wrapper.scrollLeft = previousScrollLeft;
                    }
                });

                $(`#${tableId} tbody`)
                    .off("click")
                    .on("click", ".row-checkbox", function (e) {
                        // e.preventDefault();   // <--- stop navigation/refresh
                        e.stopPropagation();

                        const encodedId = $(this).attr("data-id");

                        const decodedId = decodeURIComponent(encodedId);

                        const rowId = idKey === "targeting" || idKey === "customer_search_term"
                            ? normalizeTargeting(decodedId)
                            : decodedId?.toString();

                        if (!rowId) return;

                        if (this.checked) {
                            selectedIdsRef.current.add(rowId);
                        } else {
                            selectedIdsRef.current.delete(rowId);
                        }

                        emitGroupedSelected(null, { isBulk: false });

                        const rows = $table.rows({ page: "current" }).nodes();
                        let allChecked = true;
                        $(rows).find(".row-checkbox").each(function () {
                            if (!this.checked) allChecked = false;
                        });

                        const selectAllCheckbox = document.getElementById(`select-all-${tableId}`);
                        if (selectAllCheckbox) selectAllCheckbox.checked = allChecked;
                    });

                $(`#${tableId} tbody`).on("click", ".clickable-i", function () {
                    const key = $(this).data("key");
                    const id = $(this).data("id");
                    setInfoData({ column: key, rowId: id });
                    setShowInfoComponent(true);
                    setModalOpen(true);
                });


                $(`#${tableId} tbody`).on("click", ".clickable-parent", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const parentproductId = $(this).data("parent-id")?.toString(); // correct
                    const productId = $(this).data("product-id")?.toString();
                    const asin = $(this).data("asin")?.toString();

                    selectedIdsRef.current.clear();
                    $(".row-checkbox").prop("checked", false);
                    $("#select-all-on-page").prop("checked", false);
                    onSelectionChange?.({ categoryId: [], productId: [], parentproductId: [] });
                    if (parentproductId && typeof onParentProductClick === "function") {
                        onParentProductClick(asin, productId, parentproductId);
                    }
                });


            } catch (err) {
                console.error("Error initializing DataTable:", err);
            }
        };

        initialize();

        return () => {
            const existingTable = $(`#${tableId}`);
            if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
                $(`#${tableId}`).DataTable().destroy();
            }

            dataTableRef.current = $(`#${tableId}`).DataTable({
                pageLength: defaultPageLength,
                ordering: true,
                order: [],
                destroy: true
            });
            $(`#${tableId}`).off();
        };
    }, [refreshTrigger, data]);

    const handleConfirm = async () => {
        setModalOpenLoding(true);
        try {
            const result = await handleConnect("amazon ads");
            if (result?.success) {
                setModalOpenLoding(false);
            }
        } catch (error) {
            console.error("Connection failed:", error);
        }
    };

    const handleCancel = () => setModalOpen(false);
    const handleCancelLocation = () => setLocationModalOpen(false);

    const getSkeletonTableHTML = () => {
        const dynamicLevel = filterData?.level || "default";
        const sequence = {
            CampaignName: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            AddGroup: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            product: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            target: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            customerSearch: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            search: ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"],
            [`rrSales-${dynamicLevel}`]: ["NAME", "ACTUAL UNITS", "REFUND", "CANCELLED UNITS", "REPLACEMENT UNITS"],
        };
        // Pick headers based on tableId, or fallback to a default set
        const headers = sequence[tableId] || ["CAMPAIGN NAME", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND", "ACOS", "Ads SALES", "Ads UNITS", "ROAS", "ACTUAL ORDER VALUE", "Ads CONVERSION"];

        const skeletonRow = `
      <tr>
        ${enableSelection ? "<td><div class='skeleton-box skeleton-checkbox'></div></td>" : ""}
        ${headers.map((_, idx) => {
            if (idx === 0) {
                return `
              <td>
                <div class="skeleton-product">
                  <div class="skeleton-image"></div>
                  <div class="skeleton-text-group">
                    <div class="skeleton-title"></div>
                    <div class="skeleton-subtitle"></div>
                  </div>
                </div>
              </td>`;
            }
            return "<td><div class='skeleton-box'></div></td>";
        }).join("")}
      </tr>`;

        return `
    <div class="table-wrapper">
      <div class="table-toolbar">
        <div class="search-placeholder">
          <div class="skeleton-search-icon"></div>
          <div class="skeleton-search-input"></div>
        </div>
        <div class="export-icons">
          <div class="skeleton-icon"></div>
          <div class="skeleton-icon"></div>
        </div>
      </div>
      <table id="${tableId}" class="display table" style="width:100%">
        <thead class="table-header">
          <tr>
            ${enableSelection ? "<th class='skeleton-th'></th>" : ""}
            ${headers.map(h => `<th class='skeleton-th'>${h}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${Array.from({ length: 10 }).map(() => skeletonRow).join("")}
        </tbody>
      </table>
    </div>
    `;
    };

    const showNoDataMessage = delayedEmpty;
    return (
        <>
            <div ref={containerRef} />
            {showInfoComponent && (
                <ConfirmModal
                    show={modalOpen}
                    title="Verified Account?"
                    message="The value will be updated once your Amazon Ads account has been successfully connected."
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    loading={modalOpenLoading}
                />
            )}

            {locationModalOpen && (
                <>
                    {locationLoading ? (
                        <div
                        />
                    ) : locationData.length > 0 ? (
                        <AreaTableModal show={locationModalOpen}
                            title={selectedLocationName}
                            data={locationData}
                            categoryName={selectedLocationDetails.state || selectedLocationDetails.city || selectedLocationDetails.pincode}
                            onCancel={handleCancelLocation}
                            permission={level === "state" ? permission?.data?.area_wise_insights?.state_section?.specific_details : selectedLocationDetails.city ? permission?.data?.area_wise_insights?.city_section?.specific_details : permission?.data?.area_wise_insights?.pincode_section?.specific_details}
                        />
                    ) : (
                        <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }} className='no-data-found'>
                            No data found for the given criteria.
                        </div>

                    )}
                </>
            )}

        </>
    );
};

export default NormalTable;